import React, { useCallback, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../../axios/index";

// custome hooks

// Context
import { UserContext } from "../../Context/UserContextProvider";

import arrowIcon from "../../../assets/img/DashboardICons/ArrowRounded.svg";
import Dstyles from "../DashboardFileManagement/DashboardFileManagement.module.css";

// Styles
import stylesMain from "../DashboardFileManagement/DashboardFileManagement.module.css";
import newStyle from "./NewDashboardCategoriesManager.module.css";
// import Mainstyles from "./SavedFiles.module.css"

// Re Useable Components
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import DashboardHeader from "../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../DashboardReuseAbleComponents/DashboardSideMenu";

export default function DashboardCategoriesManagement(props) {
  const history = useHistory();

  const { userToken } = useContext(UserContext);
  const { state } = useLocation();
  const [query, setQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [isShowSidebar, setIsShowSidebar] = useState(true);

  let [editId, setEditId] = useState(0);
  let [editTitle, setEditTitle] = useState("");

  let [currentPage, setCurrentPage] = useState(1);

  let [categories, setCategories] = useState([]);
  //let [selectedCategory, setSelectedCategory] = useState(0);

  const dataHandler = useCallback(async () => {
    axios
      .get("Category?count=true", {
        headers: {
          authorization: "Bearer " + userToken,
        },
      })
      .then(res => {
        setCategories(res.data.data);
        setIsLoading(false);
      });
  }, [userToken, state]);

  useEffect(() => {
    sessionStorage.removeItem("searchData");
    sessionStorage.removeItem("pageData");
    sessionStorage.removeItem("categories");
    sessionStorage.removeItem("subCategory");
    sessionStorage.removeItem("mainCategory");
    sessionStorage.removeItem("dealType");
    sessionStorage.removeItem("filters");
  }, []);

  useEffect(() => {
    dataHandler();
  }, [dataHandler]);

  function changeSelectedCategory(id) {
    if (editId != 0) {
      setSelectedCategory(selectedCategory);
      return;
    } else {
      setSelectedCategory(id);
    }
  }

  function orderAndMapItems(items) {
    const parentMap = {};
    items.forEach(item => {
      const parentId = item.parentId || "null";
      if (!parentMap[parentId]) {
        parentMap[parentId] = [];
      }
      parentMap[parentId].push(item);
    });

    function traverse(parentId, generation = 0) {
      const ordered = [];
      const children = parentMap[parentId] || [];
      children.forEach(child => {
        const childWithGeneration = { ...child, generation };
        ordered.push(childWithGeneration);
        ordered.push(...traverse(child.id, generation + 1));
      });
      return ordered;
    }

    const orderedItems = traverse("null");

    return orderedItems;
  }

  function isParent(id) {
    let isParent = false;
    categories.forEach(category => {
      if (category.parentId == id) {
        isParent = true;
      }
    });

    return isParent;
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  let [selectedDealType, setSelectedDealType] = useState(-1); //0 for sale 1 for rent
  let [selectedMainCategory, setSSelectedMainCategory] = useState(-1);
  let [selectedSubCategory, setSelectedSubcategory] = useState(-1);
  let [selectedCategory, setSelectedCategory] = useState(-1);
  let [newFileTitle, setNewFileTitle] = useState("");

  function selectDealType(dealType) {
    setSelectedDealType(dealType);
    setCurrentPage(2);
  }

  function selectMainCategory(categoryId) {
    setSSelectedMainCategory(categoryId);
    setCurrentPage(3);
  }

  function selectSubCategory(categoryId) {
    setSelectedSubcategory(categoryId);
    setCurrentPage(4);
  }

  function selectCategory(categoryId) {
    setSelectedCategory(categoryId);
    setCurrentPage(5);
  }

  function goBackToDealType() {
    setSelectedDealType(-1);
    setCurrentPage(1);
  }

  function goBackToMainCategories() {
    setSSelectedMainCategory(-1);
    setCurrentPage(2);
  }

  function goBackToSubCategories() {
    setSelectedSubcategory(-1);
    setCurrentPage(3);
  }

  function removeCategory(id) {
    if (categories.find(c => c.parentId == id)) {
      notify("این دسته بندی دارای دسته بندی فرزند میباشد", "error");
      return;
    }
    axios
      .delete("Category/" + id)
      .then(res => {
        axios
          .get("Category?count=true", {
            headers: {
              authorization: "Bearer " + userToken,
            },
          })
          .then(res => {
            setCategories(res.data.data);
            setIsLoading(false);
          });
      })
      .catch(res => {
        setIsLoading(false);
        notify(res.message, "error");
      });
    setIsLoading(true);
  }

  function setCurrentEditing(categoryId) {
    setModalShow(true);
    setEditId(categoryId);
    setEditTitle(categories.find(e => e.id == categoryId).title);
  }

  function submitHandle() {
    if (editId == 0) {
      if (selectedSubCategory != 0) {
        axios
          .post("Category/AddChild", {
            parentId: selectedSubCategory,
            title: editTitle,
            slug: editTitle + Date.now(),
            seoData: {
              metaTitle: "Category",
              metaDescription: "Category",
              metaKeyWords: "Category",
              indexPage: true,
              canonical: "Category",
              schema: "Category",
            },
            dealType: categories.find(i => i.id == selectedSubCategory).dealType,
          })
          .then(res => {
            axios
              .get("Category?count=true", {
                headers: {
                  authorization: "Bearer " + userToken,
                },
              })
              .then(res => {
                setCategories(res.data.data);
                setIsLoading(false);
              });
          });
        setIsLoading(true);
        setModalShow(false);
        setEditId(0);
        setEditTitle("");
        return;
      } else {
        axios
          .post("Category", {
            Title: editTitle,
            Slug: editTitle + Math.floor(Math.random() * 100000),
            SeoData: {
              MetaTitle: "Category",
              MetaDescription: "Category",
              MetaKeyWords: "Category",
              IndexPage: true,
              Canonical: "Category",
              Schema: "Category",
            },
            dealType: categories.find(i => i.id == selectedSubCategory).dealType,
          })
          .then(res => {
            axios
              .get("Category?count=true", {
                headers: {
                  authorization: "Bearer " + userToken,
                },
              })
              .then(res => {
                setCategories(res.data.data);
                setIsLoading(false);
              });
          });
        setModalShow(false);
        setEditId(0);
        setEditTitle("");
        setIsLoading(true);
        return;
      }
    }
    axios
      .put("Category", {
        Id: editId,
        Title: editTitle,
        Slug: editTitle + Math.floor(Math.random() * 100000),
        SeoData: {
          MetaTitle: "Category",
          MetaDescription: "Category",
          MetaKeyWords: "Category",
          IndexPage: true,
          Canonical: "Category",
          Schema: "Category",
        },
        dealType: categories.find(i => i.id == selectedSubCategory).dealType,
      })
      .then(res => {
        axios
          .get("Category?count=true", {
            headers: {
              authorization: "Bearer " + userToken,
            },
          })
          .then(res => {
            setCategories(res.data.data);
            setIsLoading(false);
          });
      });
    setIsLoading(true);
    setModalShow(false);
    setEditId(0);
    setEditTitle("");
  }

  return (
    <>
      {isLoading ? (
        <div className={stylesMain.loader_container}>
          <div className={stylesMain.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className={`${newStyle.popup_container}`} hidden={!modalShow}>
            <div className={`${newStyle.popup_container_content}`}>
              <div className={`${newStyle.popup_container_content_header}`}>
                <div className={`${newStyle.popup_container_content_header_title}`}>
                  <div className={`${newStyle.popup_container_content_header_title_content}`}>{selectedDealType == 0 ? "فروش" : "رهن و اجاره"}</div>
                  <div className={`${newStyle.popup_container_content_header_title_content}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style={{ width: "20px", height: "20px" }}>
                      <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                    </svg>
                  </div>
                  <div className={`${newStyle.popup_container_content_header_title_content}`}>
                    {categories.find(i => i.id == selectedMainCategory)?.title || "نوع کاربری"}
                  </div>
                  <div className={`${newStyle.popup_container_content_header_title_content}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style={{ width: "20px", height: "20px" }}>
                      <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                    </svg>
                  </div>
                  <div className={`${newStyle.popup_container_content_header_title_content}`}>
                    {categories.find(i => i.id == selectedSubCategory)?.title || "نوع ملک"}
                  </div>
                </div>
                <div
                  className={`${newStyle.popup_container_content_header_title_content}`}
                  onClick={() => {
                    setModalShow(false);
                    setEditTitle("");
                    setEditId(0);
                  }}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style={{ width: "20px", height: "20px" }}>
                    <path d="M378.4 71.4c8.5-10.1 7.2-25.3-2.9-33.8s-25.3-7.2-33.8 2.9L192 218.7 42.4 40.6C33.9 30.4 18.7 29.1 8.6 37.6S-2.9 61.3 5.6 71.4L160.7 256 5.6 440.6c-8.5 10.2-7.2 25.3 2.9 33.8s25.3 7.2 33.8-2.9L192 293.3 341.6 471.4c8.5 10.1 23.7 11.5 33.8 2.9s11.5-23.7 2.9-33.8L223.3 256l155-184.6z" />
                  </svg>
                </div>
              </div>
              <div className={`${newStyle.popup_container_content_body}`}>
                <div className={`${newStyle.popup_container_content_body_label}`}>نام منطقه را وارد کنید</div>
                <div className={`${newStyle.popup_container_content_body_input}`}>
                  <input
                    placeholder="نام منطقه..."
                    style={{ border: "none" }}
                    value={editTitle}
                    onChange={ev => {
                      setEditTitle(ev.target.value);
                    }}></input>
                </div>
                <div className={`${newStyle.popup_container_content_body_submit}`} onClick={() => submitHandle()}>
                  ثبت
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className={isShowSidebar ? "col-md-9" : "col-md-12"}>
              <div className={`mt-3 px-md-0 px-2 ${stylesMain.file_cards_container}`}>
                <DashboardHeader
                  setIsShowSidebar={setIsShowSidebar}
                  isShowSidebar={isShowSidebar}
                  onClick={() => setModalShow(true)}
                  class="px-3"
                  query={query}
                  setQuery={setQuery}
                  searchHandler={() => {}}
                />
                {currentPage === 1 ? (
                  <>
                    <div className="py-2">
                      <div className="container-fluid">
                        <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                          <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2">
                            <div className="d-flex align-items-center justify-content-center">
                              <a href="#" onClick={history.goBack}>
                                <img className="ms-2" src={arrowIcon} alt="icon" />
                              </a>
                              <div className={Dstyles.text1}>مدیریت دسته بندی ها</div>
                            </div>
                          </div>
                          <div className={`${newStyle.main_container}`}>
                            <div className={`${newStyle.main_categories_container}`}>
                              <div
                                className={`${newStyle.category_button}`}
                                onClick={() => {
                                  selectDealType(0);
                                }}>
                                <div className={`${newStyle.category_button_content}`}>فروش</div>
                                <div className={`${newStyle.category_button_content}`}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style={{ width: "20px", height: "20px" }}>
                                    <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className={`${newStyle.category_button}`}
                                onClick={() => {
                                  selectDealType(1);
                                }}>
                                <div className={`${newStyle.category_button_content}`}>رهن و اجاره</div>
                                <div className={`${newStyle.category_button_content}`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`${newStyle.category_button_content}`}
                                    viewBox="0 0 320 512"
                                    style={{ width: "20px", height: "20px" }}>
                                    <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className={`${newStyle.category_button}`}
                                onClick={() => {
                                  selectDealType(2);
                                }}>
                                <div className={`${newStyle.category_button_content}`}>پیش فروش</div>
                                <div className={`${newStyle.category_button_content}`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`${newStyle.category_button_content}`}
                                    viewBox="0 0 320 512"
                                    style={{ width: "20px", height: "20px" }}>
                                    <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className={`${newStyle.category_button} ${newStyle.category_button_bottom}`}
                                onClick={() => {
                                  selectDealType(3);
                                }}>
                                <div className={`${newStyle.category_button_content}`}>مشارکت</div>
                                <div className={`${newStyle.category_button_content}`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`${newStyle.category_button_content}`}
                                    viewBox="0 0 320 512"
                                    style={{ width: "20px", height: "20px" }}>
                                    <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : currentPage === 2 ? (
                  <>
                    <div className={`${props.userAdd ? "p-0" : "py-2"}`}>
                      <div className={`${props.userAdd ? "p-0 container-fluid" : "container-fluid"}`}>
                        <div className={`d-flex justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-2 me-3"}`} dir="rtl">
                          <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2">
                            <div className="d-flex align-items-center justify-content-center">
                              <a
                                href="#"
                                onClick={() => {
                                  setCurrentPage(1);
                                }}>
                                <img className="ms-2" src={arrowIcon} alt="icon" />
                              </a>
                              <div className={Dstyles.text1}>مدیریت دسته بندی ها</div>
                            </div>
                          </div>
                          <div className={`${newStyle.main_container}`}>
                            <div className={`${newStyle.main_categories_container}`}>
                              <div
                                className={`${newStyle.categories_back_button}`}
                                onClick={() => {
                                  goBackToDealType();
                                }}>
                                <div className={`${newStyle.categories_back_button_content_svg}`}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: "20px", height: "20px" }}>
                                    <path d="M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z" />
                                  </svg>
                                </div>
                                <div className={`${newStyle.categories_back_button_content_text}`}>بازگشت به دسته بندی نوع معامله</div>
                              </div>
                              {categories.map((category, index) => {
                                if (category.dealType == selectedDealType && category.parentId == null) {
                                  let isLast =
                                    categories.filter((val, indexx) => val.dealType == selectedDealType && val.parentId == null && indexx > index).length == 0;
                                  return (
                                    <>
                                      <div
                                        className={`${newStyle.category_button} ${isLast ? newStyle.category_button_bottom : ""}`}
                                        onClick={() => {
                                          selectMainCategory(category.id);
                                        }}>
                                        <div className={`${newStyle.category_button_content}`}>{category.title}</div>
                                        <div className={`${newStyle.category_button_content}`}>
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style={{ width: "20px", height: "20px" }}>
                                            <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                          </svg>
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : currentPage === 3 ? (
                  <>
                    <div className={`${props.userAdd ? "p-0" : "py-2"}`}>
                      <div className={`${props.userAdd ? "p-0 container-fluid" : "container-fluid"}`}>
                        <div className={`d-flex justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-2 me-3"}`} dir="rtl">
                          <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2">
                            <div className="d-flex align-items-center justify-content-center">
                              <a
                                href="#"
                                onClick={() => {
                                  setCurrentPage(2);
                                }}>
                                <img className="ms-2" src={arrowIcon} alt="icon" />
                              </a>
                              <div className={Dstyles.text1}>مدیریت دسته بندی ها</div>
                            </div>
                          </div>
                          <div className={`${newStyle.main_container}`}>
                            <div className={`${newStyle.main_categories_container}`}>
                              <div
                                className={`${newStyle.categories_back_button}`}
                                onClick={() => {
                                  goBackToMainCategories();
                                }}>
                                <div className={`${newStyle.categories_back_button_content_svg}`}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: "20px", height: "20px" }}>
                                    <path d="M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z" />
                                  </svg>
                                </div>
                                <div className={`${newStyle.categories_back_button_content_text}`}>بازگشت به دسته بندی نوع کاربری</div>
                              </div>
                              {categories.map((category, index) => {
                                if (category.dealType == selectedDealType && category.parentId == selectedMainCategory) {
                                  let isLast =
                                    categories.filter(
                                      (val, indexx) => val.dealType == selectedDealType && val.parentId == selectedMainCategory && indexx > index
                                    ).length == 0;
                                  return (
                                    <>
                                      <div
                                        className={`${newStyle.category_button} ${isLast ? newStyle.category_button_bottom : ""}`}
                                        onClick={() => {
                                          selectSubCategory(category.id);
                                        }}>
                                        <div className={`${newStyle.category_button_content}`}>{category.title}</div>
                                        <div className={`${newStyle.category_button_content}`}>
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style={{ width: "20px", height: "20px" }}>
                                            <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                          </svg>
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={`${props.userAdd ? "p-0" : "py-2"}`}>
                      <div className={`${props.userAdd ? "p-0 container-fluid" : "container-fluid"}`}>
                        <div className={`d-flex justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-2 me-3"}`} dir="rtl">
                          <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2">
                            <div className="d-flex align-items-center justify-content-center">
                              <a
                                href="#"
                                onClick={() => {
                                  setCurrentPage(2);
                                }}>
                                <img className="ms-2" src={arrowIcon} alt="icon" />
                              </a>
                              <div className={Dstyles.text1}>مدیریت دسته بندی ها</div>
                            </div>
                          </div>
                          <div className={`${newStyle.main_container}`}>
                            <div className={`${newStyle.main_categories_container}`}>
                              <div
                                className={`${newStyle.categories_back_button}`}
                                onClick={() => {
                                  goBackToSubCategories();
                                }}>
                                <div className={`${newStyle.categories_back_button_content_svg}`}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: "20px", height: "20px" }}>
                                    <path d="M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z" />
                                  </svg>
                                </div>
                                <div className={`${newStyle.categories_back_button_content_text}`}>بازگشت به دسته بندی نوع ملک</div>
                              </div>
                              {categories.map((category, index) => {
                                if (category.dealType == selectedDealType && category.parentId == selectedSubCategory) {
                                  let isLast =
                                    categories.filter(
                                      (val, indexx) => val.dealType == selectedDealType && val.parentId == selectedSubCategory && indexx > index
                                    ).length == 0;
                                  return (
                                    <>
                                      <div className={`${newStyle.category_button_nohover} ${isLast ? newStyle.category_button_bottom : ""}`}>
                                        <div className={`${newStyle.category_button_content}`}>{category.title}</div>
                                        <div className={`${newStyle.category_button_content_container}`}>
                                          <div style={{ marginLeft: "20px" }}>تعداد فایل: {category.fCount || 0}</div>
                                          <div
                                            className={`${newStyle.category_button_content_button}`}
                                            onClick={() => {
                                              setCurrentEditing(category.id);
                                            }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: "15px", height: "15px" }}>
                                              <path d="M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L321 129 383 191 154.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4z" />
                                            </svg>
                                          </div>
                                          {category.fCount == 0 ? (
                                            <div className={`${newStyle.category_button_content_button}`} onClick={() => removeCategory(category.id)}>
                                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: "15px", height: "15px" }}>
                                                <path d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z" />
                                              </svg>
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              })}
                              <div
                                className={`${newStyle.categories_back_button}`}
                                onClick={() => {
                                  setModalShow(true);
                                }}>
                                <div className={`${newStyle.categories_back_button_content_text}`}>افزودن منطقه جدید</div>
                                <div className={`${newStyle.categories_back_button_content_svg}`}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: "20px", width: "20px" }}>
                                    <path d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div
              className={isShowSidebar ? "col-md-3" : "hidden"}
              style={{
                display: isShowSidebar ? "block" : "none",
              }}>
              <DashboardSideMenu manageCategories setIsShowSidebar={setIsShowSidebar} isShowSidebar={isShowSidebar} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
